import { format, addMonths, addWeeks, addDays, addYears } from 'date-fns';



const calculateDueDates = (startDate, interval, term, amount, interest, adv) => {
  const dueDates = [];
  const principalAmount = amount / term;
  const interestAmountInitial = (adv)?(amount * interest) / 100:0;
  const interestAmountMinusAdvance = (((amount * interest) / 100) * term) - interestAmountInitial;
  const interestAmount = interestAmountMinusAdvance / term;
  
  let currentDate = new Date(startDate);

  for (let i = 0; i < term; i++) {
    switch (interval.toLowerCase()) {
      case 'monthly':
        currentDate = addDays(currentDate, 31);
        break;
      case 'bimonthly': // Twice a month, roughly every two weeks
        currentDate = addWeeks(currentDate, 2);
        break;
      case 'weekly':
        currentDate = addWeeks(currentDate, 1);
        break;
      case 'quarterly':
        currentDate = addMonths(currentDate, 3);
        break;
      case 'semiannual':
        currentDate = addMonths(currentDate, 6);
        break;
      case 'yearly':
        currentDate = addYears(currentDate, 1);
        break;
      default:
        throw new Error('Invalid interval');
    }

    dueDates.push({
      date: format(currentDate, 'MM/dd/yyyy'),
      //dueAmount: roundUp(principalAmount + interestAmount)
      dueAmount: principalAmount + interestAmount
    });
  }

  return dueDates;
};


const calculatePayments = (date, interval, term, amount, interest, paymentList, adv) => {
  const dueDates = calculateDueDates(date, interval, term, amount, interest);
  const initialIntrest = (adv)?(amount * (interest/100)):0;
  const totalRepayments = dueDates.reduce((acc, due) => acc + due.dueAmount, 0);

  let totalPaid = 0;
  let remainingBalance = totalRepayments;


  let total = 0;
  let paymentdate = null;

  if (paymentList && Array.isArray(paymentList) && paymentList.length > 0) {
    paymentList.forEach(payment => {
        total += (
            parseFloat(payment.paidPrincipal || 0) + 
            parseFloat(payment.paidInterest || 0) + 
            parseFloat(payment.paidOther || 0)
        );
    });

    totalPaid = (total + initialIntrest);

    paymentdate = paymentList[paymentList.length - 1].paymentDate;
} else {
    totalPaid = initialIntrest; // only the advance interest
}

  remainingBalance = (totalRepayments - totalPaid);

  const paymentsArr = {
    'totalPaid': parseFloat(totalPaid).toFixed(2),
    'remainingBalance': parseFloat(remainingBalance).toFixed(2),
    'totalRepayments': parseFloat(totalRepayments).toFixed(2),
    'paymentDate': paymentdate
  };

  return paymentsArr;
};


export default calculatePayments;